// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__-jw_W","imageUploader":"EGiftCard_imageUploader__cZok-"};